<div [ngClass]="scaleForPinned() ? 'scale-for-pinned-image' : 'default-size'" class="avatar-body">
  @let avatarIcon = (userService.userCache | async)?.get(userId());
  <div>
    <span class="helper"></span>
    @if (avatarIcon) {
      <img
        class="avatar-image"
        [ngClass]="scaleForPinned() ? 'scale-for-pinned-image' : 'default-size-image'"
        [src]="avatarIcon"
        alt="" />
    } @else {
      <mat-icon
        class="avatar-image"
        [ngClass]="scaleForPinned() ? 'scale-for-pinned-image' : 'default-size-image'"
        mat-card-avatar
        svgIcon="default-user-icon"></mat-icon>
    }
  </div>
  @if (showStatus() && !scaleForPinned()) {
    <div class="presence-status">
      @if (presenceStatus() | async; as presenceStatus) {
        @switch (presenceStatus) {
          @case ('online') {
            <mat-icon class="status-icon" svgIcon="online"></mat-icon>
          }
          @default {
            <mat-icon class="status-icon offline" svgIcon="offline"></mat-icon>
          }
        }
      } @else {
        <mat-icon class="status-icon offline" svgIcon="offline"></mat-icon>
      }
    </div>
  }
</div>
